import { Dialog, DialogContent, useTheme } from '@mui/material';
import { FormProvider, useFormState } from 'react-hook-form';

import type { CarDto } from '~/data/schemas/car';
import { useLocaleTerms } from '~/hooks/useLocaleTerms';

import DialogBackNextActions from '../DialogBackNextActions';
import DialogTitleWithCloseButton from '../DialogTitleWithCloseButton';
import { useCarForm } from './PropertyCarForm';

interface IEditCarDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data?: CarDto) => void;
  defaultValues?: CarDto;
}

const PropertyEditCarDialog = ({ open, onClose, onSubmit, defaultValues }: IEditCarDialogProps) => {
  const theme = useTheme();
  const terms = useLocaleTerms();
  const { hookForm, Form: CarForm, Fields: CarFields } = useCarForm();
  const { isSubmitting } = useFormState({ control: hookForm.control });

  const actionBtns = {
    next: { label: isSubmitting ? 'Saving' : 'Save', enabled: !isSubmitting },
  };

  return (
    <FormProvider {...hookForm}>
      <CarForm onSubmit={onSubmit} initialData={defaultValues}>
        <Dialog open={open} onClose={onClose} maxWidth="sm" disablePortal>
          <DialogTitleWithCloseButton onClose={onClose} title={`Edit ${terms.unit}`} />
          <DialogContent
            sx={{ padding: theme.spacing(2), paddingTop: 0, overflow: 'auto', height: '100%' }}
          >
            <CarFields />
          </DialogContent>
          <DialogBackNextActions onBack={onClose} actionBtns={actionBtns} />
        </Dialog>
      </CarForm>
    </FormProvider>
  );
};

export default PropertyEditCarDialog;
